var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxMexIx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 394.5 152.2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004ef1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1748f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4f37f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6531f5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 51.294,
    x2: 99.628,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 29.164,
    y2: 125.164
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 27.74,
    x2: 76.073,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 41.023,
    y2: 137.023
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 86.457,
    x2: 134.79,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 11.461,
    y2: 107.461
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 38.764,
    x2: 87.097,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 35.473,
    y2: 131.473
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 68.122,
    x2: 116.456,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 20.692,
    y2: 116.692
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 49.748,
    x2: 98.081,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 29.943,
    y2: 125.943
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__h",
    gradientUnits: "userSpaceOnUse",
    x1: 20.39,
    x2: 68.723,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 44.724,
    y2: 140.724
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__i",
    gradientUnits: "userSpaceOnUse",
    x1: 79.106,
    x2: 127.439,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 15.162,
    y2: 111.162
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 31.374,
    x2: 79.707,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 39.194,
    y2: 135.194
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 60.732,
    x2: 109.065,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 24.413,
    y2: 120.413
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: 42.357,
    x2: 90.691,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 33.664,
    y2: 129.664
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: 12.999,
    x2: 61.333,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 48.445,
    y2: 144.445
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__n",
    gradientUnits: "userSpaceOnUse",
    x1: 71.716,
    x2: 120.049,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 18.883,
    y2: 114.883
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__o",
    gradientUnits: "userSpaceOnUse",
    x1: 23.983,
    x2: 72.316,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 42.915,
    y2: 138.915
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__p",
    gradientUnits: "userSpaceOnUse",
    x1: 53.341,
    x2: 101.675,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 28.134,
    y2: 124.134
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix_mex-ix_svg__q",
    gradientUnits: "userSpaceOnUse",
    x1: 34.967,
    x2: 83.3,
    xlinkHref: "#ix_mex-ix_svg__a",
    y1: 37.385,
    y2: 133.385
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9 148.7c-4.7 0-9.5-1.2-13.7-3.7l-36.9-21.5C14.8 118 8.9 107.7 8.9 96.6V55.5c0-11 5.9-21.3 15.4-26.9L61.2 7.1c8.4-4.9 18.9-4.9 27.4 0l36.9 21.5c9.5 5.5 15.4 15.8 15.4 26.9v41.1c0 11-5.9 21.3-15.4 26.9L88.6 145c-4.2 2.5-8.9 3.7-13.7 3.7zm0-137c-3.2 0-6.4.8-9.2 2.5L28.3 36c-6.8 4-11 11.3-11 19.3v41.6c0 7.9 4.2 15.3 11 19.3L65.7 138c5.7 3.3 12.8 3.3 18.5 0l37.4-21.8c6.8-4 11-11.3 11-19.3V55.3c0-7.9-4.2-15.3-11-19.3L84.2 14.2c-2.9-1.6-6.1-2.5-9.3-2.5z",
    fill: "url(#ix_mex-ix_svg__b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 61.6,
    fill: "url(#ix_mex-ix_svg__c)",
    r: 5.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.7,
    cy: 61.6,
    fill: "url(#ix_mex-ix_svg__d)",
    r: 5.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 70.7,
    fill: "url(#ix_mex-ix_svg__e)",
    r: 5.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3,
    cy: 70.7,
    fill: "url(#ix_mex-ix_svg__f)",
    r: 5.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.9,
    cy: 79.9,
    fill: "url(#ix_mex-ix_svg__g)",
    r: 5.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 79.9,
    fill: "url(#ix_mex-ix_svg__h)",
    r: 5.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.7,
    cy: 79.9,
    fill: "url(#ix_mex-ix_svg__i)",
    r: 5.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 89.1,
    fill: "url(#ix_mex-ix_svg__j)",
    r: 5.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3,
    cy: 89.1,
    fill: "url(#ix_mex-ix_svg__k)",
    r: 5.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.9,
    cy: 98.3,
    fill: "url(#ix_mex-ix_svg__l)",
    r: 5.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1,
    cy: 98.3,
    fill: "url(#ix_mex-ix_svg__m)",
    r: 5.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.7,
    cy: 98.3,
    fill: "url(#ix_mex-ix_svg__n)",
    r: 5.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 107.5,
    fill: "url(#ix_mex-ix_svg__o)",
    r: 5.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.3,
    cy: 107.5,
    fill: "url(#ix_mex-ix_svg__p)",
    r: 5.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.9,
    cy: 116.7,
    fill: "url(#ix_mex-ix_svg__q)",
    r: 5.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e3a42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.7 46c6.7 0 12 2.2 16 6.5s6 10.1 6 17.4v35.8h-15V70.9c0-3.5-.9-6.2-2.6-8.1s-4.1-2.9-7.2-2.9c-3.4 0-6.1 1.1-8 3.4-1.9 2.2-2.8 5.5-2.8 9.8v32.6h-15V70.9c0-3.5-.9-6.2-2.6-8.1s-4.1-2.9-7.2-2.9c-3.3 0-6 1.1-8 3.4-2 2.2-3 5.5-3 9.8v32.6h-15V47.6h8.8c3.4 0 6.2 2.8 6.2 6.2 3.5-5.2 8.9-7.8 16.1-7.8 7.1 0 12.4 2.8 15.8 8.4 4.1-5.7 9.8-8.4 17.5-8.4zM314.1 24.3h7.1v81.3h-15v-6.9c-4.4 5.7-10.7 8.5-18.8 8.5-7.8 0-14.5-3-20-8.9s-8.3-13.2-8.3-21.8 2.8-15.9 8.3-21.8 12.2-8.9 20-8.9c8.1 0 14.4 2.8 18.8 8.5V32.2c0-4.3 3.6-7.9 7.9-7.9zm-35.4 64.1c3.1 3.1 6.9 4.6 11.6 4.6s8.5-1.5 11.5-4.6 4.5-7 4.5-11.8-1.5-8.7-4.5-11.8-6.9-4.6-11.5-4.6-8.5 1.5-11.6 4.6-4.6 7-4.6 11.8 1.5 8.7 4.6 11.8zM359.3 107.3c-8.7 0-16-2.9-21.9-8.8-5.8-5.9-8.8-13.2-8.8-21.8 0-8.7 2.9-15.9 8.8-21.8 5.8-5.9 13.1-8.8 21.9-8.8 5.7 0 10.8 1.4 15.4 4.1s8.2 6.3 10.6 10.9l-7 4.1c-2.9 1.7-6.6 1.4-9.1-.8-.6-.5-1.3-1-2-1.4-2.4-1.4-5-2.1-8-2.1-4.5 0-8.2 1.5-11.1 4.5s-4.4 6.8-4.4 11.4 1.5 8.3 4.4 11.3 6.7 4.5 11.1 4.5c3 0 5.7-.7 8.1-2 2.4-1.4 4.1-3.2 5.3-5.6l13 7.4c-2.6 4.6-6.2 8.2-10.8 11-4.7 2.5-9.8 3.9-15.5 3.9z"
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIxMexIx as ReactComponent };